let counter = 0;

export const getId = (prefix = 'id') => `${prefix}-${++counter}`;
